/**
 * Libellé lisible d'une étiquette de question (question_tags.tag = clé technique sans accents,
 * ex. « piege/age-precis », « hygiene/haccp ») : « Piège · Âge précis », « Hygiène · HACCP ».
 * Accents rétablis sur les mots courants du corpus ; sigles en capitales ; le reste tel quel.
 */
const ACCENTS = {
    piege: 'piège', securite: 'sécurité', hygiene: 'hygiène', fiscalite: 'fiscalité', sante: 'santé',
    pedagogie: 'pédagogie', periscolaire: 'périscolaire', carriere: 'carrière', proportionnalite: 'proportionnalité',
    developpement: 'développement', ecole: 'école', deontologie: 'déontologie', proprete: 'propreté',
    theoricien: 'théoricien', educative: 'éducative', educatif: 'éducatif', categorie: 'catégorie',
    confidentialite: 'confidentialité', acces: 'accès', equipe: 'équipe', education: 'éducation',
    medication: 'médication', secretaire: 'secrétaire', general: 'général', reforme: 'réforme', duree: 'durée',
    desinfection: 'désinfection', hierarchie: 'hiérarchie', hierarchique: 'hiérarchique', role: 'rôle', roles: 'rôles',
    controle: 'contrôle', medico: 'médico', forcee: 'forcée', reveil: 'réveil', continuite: 'continuité',
    tracabilite: 'traçabilité', responsabilite: 'responsabilité', medicament: 'médicament', deplacement: 'déplacement',
    epreuves: 'épreuves', troisieme: 'troisième', quatrieme: 'quatrième', incompatibilites: 'incompatibilités',
    age: 'âge', precis: 'précis', mediation: 'médiation', collectivite: 'collectivité', harcelement: 'harcèlement',
    precoce: 'précoce', defectueux: 'défectueux', emotion: 'émotion', regle: 'règle', impot: 'impôt',
    echelle: 'échelle', diabete: 'diabète', eleve: 'élève', eleves: 'élèves', fievre: 'fièvre',
    equipement: 'équipement', departement: 'département', echelonne: 'échelonné', diplome: 'diplôme',
    specialite: 'spécialité', reserve: 'réserve', verification: 'vérification', vetements: 'vêtements',
    separation: 'séparation', recreation: 'récréation', adaptee: 'adaptée', cooperation: 'coopération',
    repartition: 'répartition', prevention: 'prévention', decret: 'décret', eveille: 'éveillé', laicite: 'laïcité',
    lateralite: 'latéralité', ecogeste: 'écogeste', ecrans: 'écrans', souille: 'souillé', presence: 'présence',
    etat: 'état', autorisee: 'autorisée', melange: 'mélange', mobilite: 'mobilité', communaute: 'communauté',
    comprehension: 'compréhension', sanitaire: 'sanitaire', medicaments: 'médicaments', a: 'à',
};
const SIGLES = new Set(['atsem', 'pai', 'haccp', 'aesh', 'pps', 'cdg', 'fds', 'epi', 'rgpd', 'ppms', 'mdph', 'dasri',
    'duerp', 'clp', 'acm', 'pms', 'ulis', 'igpn', 'dgf', 'ppre', 'pial', 'cvae', 'ien', 'ash', 'ess', 'cfe', 'tfpb',
    'geva', 'sco', 'tms', 'bafa', 'dmto', 'sgm', 'pap', 'cdaph', 'aura', 'b1']);

const word = (w) => (SIGLES.has(w) ? w.toUpperCase() : (ACCENTS[w] || w));

export default function tagLabel(tag) {
    return String(tag || '')
        .split('/')
        .map(part => {
            const s = part.trim().toLowerCase().split(/[-_\s]+/).filter(Boolean).map(word).join(' ');
            return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
        })
        .filter(Boolean)
        .join(' · ');
}
